import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentFlightPracticeService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-flight-practice/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student flight practice list", error);
            throw error;
        }
    },

    async findByStudentUuid(studentUuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student-flight-practice/findByStudentUuid/${studentUuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByStudentUuid student flight practice", error);
            throw error;
        }
    },

    async create(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-flight-practice/create`,
                paramsCopy
            );
            return response.data;
        } catch (error) {
            console.error("Error create student flight practice", error);
            throw error;
        }
    },

    async save(socialGroup: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-flight-practice/save`,
                socialGroup
            );
            return response.data;
        } catch (error) {
            console.error("Error save student flight practice", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/student-flight-practice/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById student flight practice", error);
            throw error;
        }
    }
}

export default studentFlightPracticeService;